/*global Ractive, RedmarineUXTemplates, BaseComponent */

// Add component to Global Ractive object
Ractive.components['ux-joyride'] = BaseComponent.extend({

	template: RedmarineUXTemplates.uxjoyrideUxjoyride,

	events: {
		enter: RactiveEventsKeys.enter
	},

	// any default data
	data: {
		component: 'ux-joyride',
		isHidden: true,
		defaultNubTop: 28,
		maxMobileWidth: 500,
		styles: {
			top: '0px',
			left: '0px',
			width: 'auto'
		}
	},

	open: function() {
		var hasJoyride  = this.find('*[aria-haspopup]'),
			joyride  = this.find('.ux-joyride'),
			documentWidth = document.documentElement.offsetWidth,
			containerWidth = this.el.parentElement.offsetWidth,
			defaultNubTop = this.get('defaultNubTop'),
			stylesObject = {};

		if (documentWidth > this.get('maxMobileWidth')) {
			stylesObject.nubPosition = 'left';
			stylesObject.top = (- defaultNubTop) + 'px';
			stylesObject.left = (hasJoyride.offsetWidth + hasJoyride.offsetLeft + defaultNubTop) + 'px';
			stylesObject.joyrideNubTop = defaultNubTop + 'px';
			stylesObject.width = (containerWidth - joyride.offsetWidth - joyride.offsetLeft - defaultNubTop) + 'px';
		} else {
			stylesObject.nubPosition = 'top';
			stylesObject.top = defaultNubTop + 'px';
			stylesObject.left = '0px';
			stylesObject.joyrideNubTop = (- defaultNubTop) + 'px';
			stylesObject.width = (containerWidth - joyride.offsetLeft - 2) + 'px';
		}

		this.set('styles', stylesObject);

		this.set('isHidden', false);
		_.defer(function() {
			hasJoyride.focus();
		});

	},

	close: function() {
		var hasJoyride  = this.find('*[aria-haspopup]');

		hasJoyride.focus();
		this.set('isHidden', true);
	},

	// add you behaviors here
	onrender: function() {
		this.on('toggle', function(event) {
			event.original.preventDefault();

			// calculate the current positioning of the joyride
			if (this.get('isHidden')) {
				this.open();
			} else {
				this.close();
			}

			return false;
		});

		this.on('close', function(event) {
			event.original.preventDefault();

			this.close();

			return false;
		});
	}
});
